export default {
  nav: { models: "Modelli", gallery: "Galleria", fleet: "Flotte & B2B", contact: "Contatto" },
  cta: { testDrive: "Prenota un test drive" },
  hero: {
    overline: "Importatore generale ufficiale per la Svizzera",
    title: "Il futuro è elettrico. Ora anche in Svizzera.",
    subtitle: "I veicoli elettrici Skyworth uniscono grande autonomia, tecnologia all'avanguardia e un'assistenza svizzera affidabile – dal test drive alla manutenzione.",
    btnModels: "Scopri i modelli",
  },
  stats: [
    { value: "30'000+", label: "Collaboratori in tutto il mondo nel gruppo Skyworth" },
    { value: "7 anni", label: "Garanzia del costruttore sul BE11" },
    { value: "489 km", label: "Autonomia WLTP (BE11 Long Range)" },
    { value: "100%", label: "Assistenza direttamente dalla Svizzera" },
  ],
  showcase: {
    overline: "Modelli",
    title: "Un modello per ogni esigenza.",
    allLink: "Tutti i modelli in dettaglio",
    discover: "Scopri",
  },
  brand: {
    overline: "Il marchio",
    title: "Da gruppo dell'elettronica a pioniere dell'elettromobilità.",
    text: "Skyworth è un gruppo tecnologico globale con oltre 30'000 collaboratori – dall'elettronica di consumo alle soluzioni energetiche intelligenti. Con Skywell il marchio porta questo know-how su strada: veicoli elettrici robusti, con dotazioni generose e garanzie solide.",
    bullets: [
      "Fondata nel 2000 – oltre due decenni di esperienza",
      "Veicoli in circolazione in Europa, Asia e Australia",
      "Auto + Home: dal veicolo alle soluzioni energetiche per la casa",
    ],
  },
  videoSection: {
    overline: "Film",
    title: "Skyworth in movimento.",
    text: "Scopri design, tecnologia e piacere di guida della gamma Skyworth nel film ufficiale del marchio.",
  },
  fleetHome: {
    overline: "Flotte & B2B",
    title: "L'elettromobilità per la tua azienda.",
    text: "Dalla singola auto aziendale all'intera flotta: ti consigliamo personalmente su scelta dei veicoli, infrastruttura di ricarica e gestione – con contatto diretto al costruttore e assistenza dalla Svizzera.",
    button: "Invia una richiesta flotte",
  },
  service: {
    overline: "Assistenza & fiducia",
    title: "Il tuo interlocutore in Svizzera.",
    cards: [
      { title: "Importatore generale ufficiale", text: "Accesso diretto al costruttore – senza deviazioni, con tutti i vantaggi per te." },
      { title: "Showroom & assistenza in Svizzera", text: "Consulenza personale, test drive e manutenzione direttamente sul posto." },
      { title: "Garanzia & ricambi sul posto", text: "Garanzia del costruttore di 7 anni e fornitura svizzera di pezzi di ricambio." },
    ],
  },
  ctaSection: {
    title: "Convinciti di persona – con un test drive.",
    text: "Prova dal vivo autonomia, silenziosità e piacere di guida. Ti ricontattiamo entro 24 ore con una proposta di appuntamento.",
    btnPrimary: "Prenota subito un test drive",
  },
  footer: {
    tagline: "Importatore generale ufficiale dei veicoli elettrici Skyworth & Skywell in Svizzera. Showroom, assistenza, garanzia e ricambi – tutto sul posto.",
    navTitle: "Navigazione",
    contactTitle: "Contatto",
    rights: "SkyworthCars Svizzera. Tutti i diritti riservati.",
    legal: "Impressum & informativa sulla privacy in arrivo.",
    youtube: "Skyworth Auto su YouTube",
  },
  galleryPage: {
    overline: "Galleria",
    title: "Grandi immagini. Tutti i modelli.",
    subtitle: "Foto e video ufficiali dei veicoli – scegli un modello e sfoglia la galleria.",
    explore: "Scopri il modello",
    videoTitle: "Video",
  },
  modelsPage: {
    overline: "Gamma di modelli",
    title: "Tutti i modelli Skyworth per la Svizzera.",
    subtitle: "Dal SUV elettrico efficiente all'ammiraglia di lusso – scopri la gamma con foto, dati tecnici e dotazioni.",
    loading: "Caricamento dei modelli …",
  },
  detail: {
    back: "Tutti i modelli",
    testDrive: "Prenota un test drive",
    consult: "Richiedi una consulenza",
    about: "Su questo modello",
    specs: "Dati tecnici",
    disclaimer: "Tutte le indicazioni senza garanzia. Con riserva di modifiche ed errori.",
    photos: "Foto & impressioni",
    videoSoon: "Sezione video: i video ufficiali dei modelli seguiranno a breve.",
    ctaTitle: "Vivere la {{name}} dal vivo?",
    ctaBtn: "Fissa un test drive",
    notFound: "Modello non trovato",
    notFoundBack: "Torna alla panoramica dei modelli",
    loading: "Caricamento …",
  },
  testDrivePage: {
    overline: "Test drive",
    title: "Prenota il tuo test drive.",
    subtitle: "Scegli il modello e la data preferiti – ti ricontattiamo entro 24 ore con una conferma.",
  },
  contactPage: {
    overline: "Contatto",
    title: "Siamo a tua disposizione.",
    subtitle: "Domande su un modello, sulla disponibilità o sull'assistenza? Scrivici o chiamaci direttamente.",
    directTitle: "Contatto diretto",
    showroomTitle: "Showroom & assistenza",
    hours: "Orari di apertura su richiesta",
  },
  fleetPage: {
    overline: "Flotte & B2B",
    title: "La tua flotta. Elettrica. Assistita in Svizzera.",
    subtitle: "Riduci costi operativi ed emissioni – con i veicoli elettrici Skyworth, una consulenza personale e un'assistenza affidabile direttamente dalla Svizzera.",
    scrollBtn: "Invia una richiesta",
    cards: [
      { title: "Soluzioni per flotte", text: "Dalla singola auto aziendale all'intera flotta – offerte su misura per le aziende svizzere." },
      { title: "Infrastruttura di ricarica", text: "Consulenza sulle soluzioni di ricarica presso la sede aziendale e Vehicle-to-Load per l'uso mobile." },
      { title: "Partnership di assistenza", text: "Contatto diretto con l'importatore generale: gestione della garanzia, ricambi e manutenzione da un'unica fonte." },
    ],
    vans: {
      overline: "Veicoli commerciali",
      title: "Anche per la tua logistica: lo Skyworth HONGTU Cargo Van.",
      text: "Furgoni e veicoli commerciali elettrici per le consegne urbane – disponibili su richiesta per la tua flotta.",
      button: "Dati tecnici & dettagli del HONGTU V9",
      cargoLabel: "HONGTU Cargo Van · Trasporto merci",
      passengerLabel: "HONGTU Passenger Van · Trasporto persone",
    },
    formSection: { overline: "Richiesta flotte", title: "Raccontaci le tue esigenze." },
    personal: "Preferisci parlare di persona?",
    personalLink: "Fissa un test drive per il tuo team",
  },
  form: {
    name: "Nome",
    email: "E-mail",
    phone: "Telefono",
    company: "Azienda",
    model: "Modello",
    modelPlaceholder: "Scegli un modello (opzionale)",
    consultation: "Consulenza desiderata",
    date: "Data preferita",
    message: "Messaggio",
    messagePlaceholder: "Il tuo messaggio …",
    namePlaceholder: "Nome e cognome",
    privacy: "Inviando il modulo accetti che possiamo contattarti in merito alla tua richiesta.",
    submitProbefahrt: "Richiedi un test drive",
    submitKontakt: "Invia il messaggio",
    submitFlotte: "Invia la richiesta flotte",
    sending: "Invio in corso …",
    successProbefahrt: "Grazie mille! Ti ricontattiamo entro 24 ore per il tuo test drive.",
    successKontakt: "Grazie per la tua richiesta! Ti risponderemo al più presto.",
  },
  status: {
    available: "Disponibile",
    orderable: "Ordinabile",
    soon: "Presto disponibile",
    onRequest: "Su richiesta",
  },
  priceOnRequest: "Prezzo su richiesta",
  models: {
    be11: {
      category: "SUV elettrico",
      tagline: "Il SUV 100% elettrico – passare all'elettrico, in tutta semplicità.",
      description: "Lo Skywell BE11 rende il passaggio all'elettrico semplice: grande autonomia, ricarica rapida e oltre 30 sistemi di assistenza intelligenti. A ciò si aggiungono un abitacolo spazioso e di pregio e una dotazione che non lascia nulla a desiderare – dalla telecamera a 360° al tetto apribile panoramico.",
      features: [
        "Touchscreen da 12.8\" + display conducente digitale da 12.3\"",
        "Apple CarPlay & Android Auto (wireless)",
        "Telecamera panoramica a 360° & assistenza al parcheggio",
        "Oltre 30 sistemi di assistenza alla guida (ADAS): tra cui ACC, AEB, LKA, RCTA",
        "Tetto apribile panoramico (apribile)",
        "Sedili anteriori riscaldati & ventilati, funzione memory",
        "Ricarica wireless dello smartphone, presa 230 V (V2L)",
        "Portellone elettrico con apertura a sensore",
      ],
      specs: [
        ["Batteria", "72 kWh / 86 kWh"],
        ["Autonomia (WLTP)", "fino a 489 km"],
        ["Potenza", "150 kW (204 CV) / 320 Nm"],
        ["Ricarica rapida DC", "fino a 80 kW (10–80% in ca. 36–45 min)"],
        ["Ricarica AC", "11 kW"],
        ["Trazione", "Trazione anteriore"],
        ["Lunghezza × larghezza × altezza", "4'720 × 1'908 × 1'696 mm"],
        ["Passo", "2'800 mm"],
        ["Bagagliaio", "689–1'608 litri"],
        ["Vehicle-to-Load (V2L)", "Sì – presa 230 V a bordo"],
        ["Infotainment", "Touchscreen da 12.8\" + display conducente da 12.3\""],
        ["Impianto audio", "Metz® con 8 altoparlanti & subwoofer"],
        ["Garanzia", "Garanzia del costruttore di 7 anni"],
      ],
    },
    "ht-i": {
      category: "SUV ibrido plug-in",
      tagline: "Elettrico nella quotidianità, senza pensieri nei lunghi viaggi.",
      description: "Lo Skyworth HT-i combina un efficiente motore 1.5 litri con una potente motorizzazione elettrica. Nella guida quotidiana viaggi in modalità puramente elettrica – in viaggio la motorizzazione ibrida garantisce un'autonomia totale fino a 1'267 km. Il veicolo ideale per chi cerca flessibilità senza pianificare le ricariche.",
      features: [
        "Guida puramente elettrica nella quotidianità",
        "Nessuna pianificazione delle ricariche sulle lunghe distanze",
        "Abitacolo da SUV generoso",
        "Infotainment moderno & sistemi di assistenza",
      ],
      specs: [
        ["Motorizzazione", "Ibrido plug-in (1.5 l + motore elettrico)"],
        ["Autonomia totale", "fino a 1'267 km (dato del costruttore)"],
        ["Autonomia puramente elettrica", "fino a ca. 200 km (dato del costruttore)"],
        ["Carrozzeria", "SUV 5 porte, 5 posti"],
        ["Garanzia", "Garanzia del costruttore – dettagli su richiesta"],
      ],
    },
    ce11: {
      category: "SUV elettrico di lusso",
      tagline: "Lusso e prestigio – l'ammiraglia della gamma Skyworth.",
      description: "Lo Skyworth CE11 ridefinisce il lusso elettrico: un abitacolo panoramico generoso, uno schermo a soffitto curvo a scomparsa e 21 altoparlanti creano un'esperienza immersiva. Con Smart AI (Swaiot GPT) il veicolo diventa un compagno intelligente.",
      features: [
        "Abitacolo panoramico generoso",
        "Schermo a soffitto curvo a scomparsa",
        "21 altoparlanti per un'esperienza sonora immersiva",
        "Assistente vocale Smart AI · Swaiot GPT",
        "Materiali e finiture di lusso",
      ],
      specs: [
        ["Motorizzazione", "100% elettrico"],
        ["Carrozzeria", "SUV di lusso"],
        ["Impianto audio", "21 altoparlanti"],
        ["Ulteriori dati tecnici", "seguiranno a breve"],
      ],
    },
    ev6: {
      category: "SUV elettrico",
      tagline: "Il collaudato SUV elettrico della prima generazione Skyworth.",
      description: "Lo Skyworth EV6 è il SUV elettrico collaudato con cui il marchio ha conquistato il mercato internazionale. Tecnologia affidabile, abitacolo generoso con tetto apribile panoramico e sistema di connessione SKYLINK: una scelta solida per entrare nell'elettromobilità.",
      features: [
        "SKYLINK Intelligent Networking – auto & casa connesse",
        "Tetto apribile panoramico",
        "Assistenza alla guida L2.5 con oltre 15 funzioni",
        "Sistema audio & video immersivo",
        "Abitacolo generoso con modalità di seduta flessibili",
      ],
      specs: [
        ["Motorizzazione", "100% elettrico"],
        ["Batteria", "60.2 kWh"],
        ["Autonomia", "fino a 434 km (NEDC)"],
        ["Accelerazione 0–100 km/h", "6.7 s"],
        ["Ricarica rapida DC", "20–70% in ≤ 32 min"],
        ["Carrozzeria", "SUV 5 porte, 5 posti"],
        ["Garanzia", "Garanzia del costruttore – dettagli su richiesta"],
      ],
    },
    hongtu: {
      category: "Furgone elettrico",
      tagline: "Furgone 100% elettrico per la logistica professionale.",
      description: "Lo Skyworth HONGTU V9 è il furgone 100% elettrico per la logistica urbana e le consegne dell'ultimo miglio: fino a 14 m³ di volume di carico, oltre 1'400 kg di portata utile e fino a 408 km di autonomia. Grazie alla ricarica rapida DC da 120 kW è di nuovo operativo in circa 36 minuti – zero emissioni, zero compromessi.",
      features: [
        "Due varianti di carrozzeria: L2H2 e L3H4",
        "Larghezza di carico di 1'403 mm tra i passaruota",
        "Design aerodinamico (cx 0.29) per un'elevata efficienza",
        "Ricarica rapida DC per tempi di fermo minimi",
        "Ideale per logistica urbana, artigianato e ultimo miglio",
        "Disponibile anche come Passenger Van (versione passeggeri)",
      ],
      specs: [
        ["Motorizzazione", "100% elettrico, 150 kW (204 CV) / 370 Nm"],
        ["Batteria", "fino a 100.9 kWh (CATL)"],
        ["Autonomia (WLTP)", "fino a 408 km"],
        ["Ricarica rapida DC", "fino a 120 kW (20–80% in ca. 36 min)"],
        ["Volume di carico", "9 m³ (L2H2) / 14 m³ (L3H4)"],
        ["Portata utile", "fino a 1'464 kg"],
        ["Peso totale ammesso", "4'250 kg"],
        ["Lunghezza × larghezza × altezza", "5'490–5'990 × 1'990 × 2'200–2'700 mm"],
        ["Coefficiente di resistenza", "cx 0.29"],
        ["Garanzia", "Garanzia del costruttore – dettagli su richiesta"],
      ],
    },
    "hongtu-passenger": {
      category: "Minibus elettrico",
      tagline: "Spazio. Comfort. Efficienza – la navetta elettrica.",
      description: "Lo Skyworth HONGTU Passenger Van porta fino a 17 persone a destinazione in modo silenzioso e a zero emissioni – ideale per navette alberghiere, transfer aeroportuali e aziende. Con 2'025 mm di altezza interna, comodi sedili singoli (opzionalmente con funzione massaggio) e moderni sistemi di assistenza, il tuo gruppo viaggia rilassato. La batteria capiente e la ricarica rapida da 120 kW riducono al minimo i tempi di sosta.",
      features: [
        "Fino a 17 posti a sedere per navette e trasporto di gruppi",
        "Comodi sedili singoli, opzionalmente con funzione massaggio",
        "Altezza interna di 2'025 mm – salita e discesa agevoli",
        "Motorizzazione silenziosa e a zero emissioni per navette hotel & città",
        "Piattaforma modulare: disponibile anche come Cargo Van",
      ],
      specs: [
        ["Motorizzazione", "100% elettrico, fino a 150 kW (204 CV), trazione posteriore"],
        ["Batteria", "fino a 100.9 kWh (CATL)"],
        ["Autonomia (WLTP)", "fino a ca. 408 km"],
        ["Ricarica rapida DC", "fino a 120 kW (20–80% in ca. 36 min)"],
        ["Posti a sedere", "fino a 17 (a seconda della configurazione)"],
        ["Altezza interna", "2'025 mm in piedi"],
        ["Infotainment", "Display centrale da 12.8\""],
        ["Sistemi di assistenza", "Assistenza alla guida L2+ (ADAS)"],
        ["Garanzia", "Garanzia del costruttore – dettagli su richiesta"],
      ],
    },
  },
};
